import React, { useRef } from 'react';

import { NumericInputWrapper, ButtonWrapper, Input, Icon24 } from './styles';

const NoneNegativeNumericInput = props => {
  const { onMinusClick, onInputChange, onPlusClick, value, className, backgroundColor, hoverColor, selectedColor, iconMinus, iconPlus, borderRadius = '0px' } = props;
  const inputRef = useRef(null);
  const disabled = value <= 1;

  const handleInput = e => {
    if (e.target.value) {
      const value = e.target.value.replace(/[^1-9\d]+/g, '').replace(/^0+/, '');
      const valid = /^[1-9]\d*$/.test(value);

      if (valid) {
        onInputChange(parseInt(value, 10));
      } else if (!value) {
        onInputChange('');
      }
    } else {
      onInputChange('');
    }
  };

  const handleFocus = () => {
    inputRef.current?.select();
  };

  return (
    <NumericInputWrapper className={className} backgroundColor={backgroundColor} borderRadius={borderRadius}>
      <ButtonWrapper disabled={disabled} onClick={disabled ? null : onMinusClick}>
        <Icon24 hoverBoxShadow={!disabled} src={iconMinus} />
      </ButtonWrapper>
      <Input
        ref={inputRef}
        className={className}
        type="text"
        value={value}
        hoverColor={hoverColor}
        selectedColor={selectedColor}
        backgroundColor={backgroundColor}
        onFocus={handleFocus}
        onChange={handleInput}
      />
      <ButtonWrapper onClick={onPlusClick}>
        <Icon24 hoverBoxShadow src={iconPlus} />
      </ButtonWrapper>
    </NumericInputWrapper>
  );
};

export default NoneNegativeNumericInput;
